import { getInitCookie, SKIPPED } from '@datadog/browser-core';
import { createCookieObservable } from '../../browser/cookieObservable';
export var CI_VISIBILITY_TEST_ID_COOKIE_NAME = 'datadog-ci-visibility-test-execution-id';
export function startCiVisibilityContext(configuration, hooks) {
  var cookieObservable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createCookieObservable(configuration, CI_VISIBILITY_TEST_ID_COOKIE_NAME);

  var _a;

  var testExecutionId = getInitCookie(CI_VISIBILITY_TEST_ID_COOKIE_NAME) || ((_a = window.Cypress) === null || _a === void 0 ? void 0 : _a.env('traceId'));
  var cookieObservableSubscription = cookieObservable.subscribe(function (value) {
    testExecutionId = value;
  });
  hooks.register(0
  /* HookNames.Assemble */
  , function (_ref) {
    var eventType = _ref.eventType;

    if (typeof testExecutionId !== 'string') {
      return SKIPPED;
    }

    return {
      type: eventType,
      session: {
        type: "ci_test"
        /* SessionType.CI_TEST */

      },
      ci_test: {
        test_execution_id: testExecutionId
      }
    };
  });
  return {
    stop: function stop() {
      cookieObservableSubscription.unsubscribe();
    }
  };
}